import { axiosInstanceMain } from '../../../utils/axiosGlobalUtils'
import { ITenant } from '../../AbmLocalPage/types'

export const getAnuncios = async (codLocal: any, tenant: ITenant) => {
  return await axiosInstanceMain.get(`/${tenant.path}/anuncios/home-vendedor/${codLocal}`);
};
